/**
 * Check if dev auto-login is enabled.
 * Returns true ONLY if:
 * 1. REACT_APP_APP_ENV is exactly "local" (case-insensitive)
 * 2. REACT_APP_DEV_AUTO_LOGIN_USER_ID is set and not empty
 * 3. REACT_APP_APP_ENV does NOT contain "prod" or "staging" (safety check)
 */
export const isDevAutoLoginEnabled = () => {
  const appEnv = (process.env.REACT_APP_APP_ENV || '').toLowerCase();
  const autoLoginUserId = process.env.REACT_APP_DEV_AUTO_LOGIN_USER_ID;

  // Safety: Never enable if env contains prod or staging
  if (appEnv.includes('prod') || appEnv.includes('staging')) {
    return false;
  }

  // Safety: Only allow on localhost
  const hostname = window.location.hostname;
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    return false;
  }

  // Only enable if APP_ENV is exactly 'local' AND user ID is provided
  return appEnv === 'local' && Boolean(autoLoginUserId);
};

/**
 * Get the user ID to auto-login as
 */
export const getDevAutoLoginUserId = () => {
  return process.env.REACT_APP_DEV_AUTO_LOGIN_USER_ID;
};

/**
 * LocalStorage key for dev mode warning dismissal
 */
export const DEV_MODE_WARNING_DISMISS_KEY = "devModeWarningDismissed";

/**
 * Height of the dev mode warning banner in pixels
 */
export const DEV_BANNER_HEIGHT = "38px";

/**
 * Clear dev mode warning dismissal from localStorage
 */
export const clearDevModeWarningDismissal = () => {
  localStorage.removeItem(DEV_MODE_WARNING_DISMISS_KEY);
};
